import { render, staticRenderFns } from "./ExpenseRecord.vue?vue&type=template&id=1176d4d3&"
import script from "./ExpenseRecord.vue?vue&type=script&lang=js&"
export * from "./ExpenseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports